(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('WizardService', WizardService);

    WizardService.$inject = ['$resource', 'ENV'];

    function WizardService($resource, ENV) {
        function saveInitSetup() {
            var url = ENV.API_BASE_URL + 'api/save-init-wizard';
            return $resource(url, {}, {});
        }

        function saveInitSetupEvent() {
            var url = ENV.API_BASE_URL + 'api/save-init-wizard-event';
            return $resource(url, {}, {});
        }

        return {
            saveInitSetup: saveInitSetup,
            saveInitSetupEvent: saveInitSetupEvent
        }


    }
})();
